import React from "react";

function getPaginationInfo(pageNumber, pageSize, totalPages) {
  let pageNumberList = [];
  if (totalPages > 1) {
    if (totalPages === 2) {
      pageNumberList = [1, 2];
    } else {
      if (totalPages <= 4) {
        if (pageNumber === 1 || pageNumber === 2) {
          pageNumberList = [1, 2, 3];
        } else if (pageNumber === totalPages) {
          pageNumberList = [pageNumber - 2, pageNumber - 1, pageNumber];
        } else {
          pageNumberList = [pageNumber - 1, pageNumber, pageNumber + 1];
        }
      } else {
        if (pageNumber <= 3) {
          pageNumberList = [1, 2, 3, 4, 5];
        } else if (pageNumber === totalPages) {
          pageNumberList = [
            pageNumber - 4,
            pageNumber - 3,
            pageNumber - 2,
            pageNumber - 1,
            pageNumber,
          ];
        } else if (pageNumber === totalPages - 1) {
          pageNumberList = [
            pageNumber - 3,
            pageNumber - 2,
            pageNumber - 1,
            pageNumber,
            pageNumber + 1,
          ];
        } else {
          pageNumberList = [
            pageNumber - 2,
            pageNumber - 1,
            pageNumber,
            pageNumber + 1,
            pageNumber + 2,
          ];
        }
      }
    }
  }
  return {
    pageNumber,
    pageSize,
    totalPages,
    pageNumberList,
    isNext: pageNumber < totalPages,
    isPrev: pageNumber > 1,
  };
}

// Add basic CSS styles as in your example
const paginationStyle = {
  marginTop: "1px",
  width: "100%",
  paddingTop: "14px",
};
const tableStyle = {
  border: `2px solid white`,
  margin: "auto",
};
const spanStyle = (isActive) => ({
  color: "black",
  fontSize: "18px",
  fontFamily: "Open Sans",
  padding: "10px",
  border: "0px solid red",
  fontWeight: isActive ? "bold" : "normal",
  lineHeight: "10px",
  verticalAlign: "top",
  cursor: "pointer",
});
const chevronStyle = (enabled, left) => ({
  color: enabled ? "black" : "lightGray",
  fontSize: "22px",
  paddingRight: left ? "10px" : undefined,
  paddingLeft: left ? undefined : "10px",
  paddingBottom: "10px",
  border: "0px solid red",
  lineHeight: "30px",
  verticalAlign: "top",
  cursor: enabled ? "pointer" : "default",
});

const PaginationOffsetLimit = ({
  pageOffset,
  pageLimit,
  totalCount,
  setPageOffset,
}) => {
  const totalPages = Math.max(1, Math.ceil(totalCount / pageLimit));
  const pageNumber = pageOffset + 1; // pageOffset is 0-based
  const { pageNumberList, isPrev, isNext } = getPaginationInfo(
    pageNumber,
    pageLimit,
    totalPages
  );

  if (totalPages <= 1) return null;

  return (
    <div style={paginationStyle}>
      <table style={tableStyle}>
        <tbody>
          <tr style={{ backgroundColor: "white" }}>
            <td>
              <span
                style={chevronStyle(isPrev, true)}
                className="fa fa-chevron-left fa-lg"
                onClick={() => {
                  if (isPrev) setPageOffset(pageOffset - 1);
                }}
              />
            </td>
            {pageNumberList.map((pageNo) => (
              <td key={`paginationTD${pageNo}`}>
                <span
                  style={spanStyle(pageNo === pageNumber)}
                  onClick={() => setPageOffset(pageNo - 1)}
                >
                  {pageNo}
                </span>
              </td>
            ))}
            <td>
              <span
                style={chevronStyle(isNext, false)}
                className="fa fa-chevron-right fa-lg"
                onClick={() => {
                  if (isNext) setPageOffset(pageOffset + 1);
                }}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PaginationOffsetLimit;



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/V2Audit/PaginationOffsetLimit.js